import { render, staticRenderFns } from "./editAttribute.vue?vue&type=template&id=024d120e&scoped=true&"
import script from "./editAttribute.vue?vue&type=script&lang=js&"
export * from "./editAttribute.vue?vue&type=script&lang=js&"
import style0 from "./editAttribute.vue?vue&type=style&index=0&id=024d120e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d120e",
  null
  
)

component.options.__file = "editAttribute.vue"
export default component.exports